import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { postData, getRemoteUrl } from './request'
import { addCases } from './utils'


function setErrorState(state, { error }) {
    state.isLoading = false
    state.sent = false
    state.resetDone = false
    state.error = error
}

function setRecoverFulfilled(state) {
    state.isLoading = false
    state.sent = true
    delete state.error
}

function setRecoverPending(state) {
    state.isLoading = true
    state.sent = false
    state.resetDone = false
    delete state.error
}

function setResetFulfilled(state) {
    state.isLoading = false
    state.resetDone = true
    delete state.error
}

function setResetPending(state) {
    state.isLoading = true
    state.resetDone = false
    state.sent = false
    delete state.error
}

function recoverPassword({ email }) {
    return postData(getRemoteUrl('auth/recover'), { email })
}

function resetPassword({ token, new_password }) {
    return postData(getRemoteUrl('auth/reset'), { token, new_password })
}

export const asyncRecoverPassword = createAsyncThunk('asyncRecoverPassword', recoverPassword)
export const asyncResetPassword = createAsyncThunk('asyncResetPassword', resetPassword)

export const recoverySlice = createSlice({
    name: 'recovery',
    initialState: {
        isLoading: false,
        sent: false,
        resetDone: false
    },
    reducers: {
        resetRecoveryState(state) {
            state.isLoading = false
            state.sent = false
            state.resetDone = false
            delete state.error
        }
    },
    extraReducers: builder => {
        addCases(builder, asyncRecoverPassword, setRecoverFulfilled, setRecoverPending, setErrorState)
        addCases(builder, asyncResetPassword, setResetFulfilled, setResetPending, setErrorState)
    }
})

export const { resetRecoveryState } = recoverySlice.actions